import { useEffect, useState } from 'react';
import { db } from '../../../FirebaseConfig';
import { ref, get } from 'firebase/database';
import './OrgInfo.css'


const OrgInfo = ({ queueId }) => {
  const [queueData, setQueueData] = useState(null);
  const [orgId, setOrgId] = useState(null)
  const [orgData, setOrgData] = useState(null)
  const [isHovered, setIsHovered] = useState(false)



  useEffect(() => {
    const fetchQueueData = async () => {
      if (queueId) {
        const queueRef = ref(db, `queues/${queueId}`);
        try {
          const snapshot = await get(queueRef);
          
          if (snapshot.exists()) {
            setQueueData(snapshot.val()); 
            if (snapshot.val().organizationId){
                setOrgId(snapshot.val().organizationId)
            }else{
                setOrgId(null)
                setOrgData(null)
            }
          } else {
            setQueueData(null);
          }
        } catch (error) {
          console.error("Error fetching data: ", error);
        }
      }
    };

    fetchQueueData(); // Call the async function inside useEffect

  }, [queueId]);

  useEffect(()=>{
    const fetchOrgData = async()=>{
        if (orgId){
            const orgRef = ref(db, `organizations/${orgId}`)
            try {
                const orgSnapshot = await get(orgRef);
                if(orgSnapshot.exists()){
                    setOrgData(orgSnapshot.val())

                }else{
                    setOrgData(null)
                }
            }catch(e){
                console.error(e)
            }
        }
    }
    fetchOrgData();
  }, [orgId])

  return (
    orgData ? (
        <div className="org_tooltip"  onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>   
            {orgData.logoImg ? <img src={orgData.logoImg} alt={`${orgData.orgName} logo`}/> : <img src="/images/orgLogoPlaceholder.png" alt="Organization logo placeholder"/>}
            {isHovered && (<p className='org_tooltiptext'> <span className='org-name'>{orgData.orgName}</span><br/>{orgData.description !== 'description was not added' && orgData.description}</p>)}
    </div>
    ) : <img className="icon-placeholder" src="/images/orgLogoPlaceholder.png" alt="Organization logo placeholder"/>
  );
  
};

export default OrgInfo;
